import { stripNbsp } from "@src/utils";
import { writeToClipboardWithPimsFormat } from "@src/utils/clipboard";
import mixpanel from "mixpanel-browser";

import { NORMAL_ON_EXAM } from "../../../constants";
import { stripMarkdown } from "../../../utils/text";
import { alert } from "../../common/Alert";
import { getObjectiveFieldsString } from "../../common/clinical/utils";

export function copyClientSummary({ clientSummary, format }) {
  return writeToClipboardWithPimsFormat(clientSummary, format)
    .then(() => {
      alert(
        "info",
        "Your client summary has been copied to your clipboard!",
      );
      mixpanel.track("Copied Note", {
        copyType: "client_summary",
        pimsExportFormat: format,
      });
    })
    .catch(() => alert("error", "Failed to copy to clipboard."));
}

export function copyAll({
  note,
  isForSharedExport,
  plainText = false,
  format,
}) {
  let textToCopy = "";

  const capitalCopy =
    localStorage.getItem("should-use-capital-subtitles-copy") ===
    "true"
      ? true
      : false;

  const styledSub = !capitalCopy ? "Subjective" : "SUBJECTIVE";
  const styledObj = !capitalCopy ? "Objective" : "OBJECTIVE";
  const styledAssess = !capitalCopy ? "Assessment" : "ASSESSMENT";
  const styledPlan = !capitalCopy ? "Plan" : "PLAN";
  const styledAddNotes = !capitalCopy
    ? "Additional Notes"
    : "ADDITIONAL NOTES";

  const effectiveFormat = plainText ? "plain_text" : format;
  const strip =
    effectiveFormat === "plain_text" ? stripMarkdown : (t) => t;

  if (note?.shouldUseCustomForm) {
    if (note?.customText) {
      textToCopy = strip(note?.customText);
    } else {
      textToCopy = strip(note?.customFormFields[0]?.textValue);
    }
  } else {
    textToCopy = textToCopy + `${styledSub}: \n`;
    textToCopy =
      textToCopy +
      (note?.subjective && note?.subjective.length > 0
        ? strip(note?.subjective)
        : "");
    textToCopy = textToCopy + "\n\n";

    textToCopy = textToCopy + `${styledObj}: \n`;

    if (note?.shouldUseGenericObjective) {
      if (note?.weight && note?.weight !== NORMAL_ON_EXAM) {
        textToCopy = textToCopy + "Weight: " + note?.weight + "\n";
      }
      textToCopy =
        textToCopy +
        (note?.objective && note?.objective.length > 0
          ? strip(note?.objective)
          : "");
    } else {
      textToCopy = textToCopy + strip(getObjectiveFieldsString(note));
    }
    textToCopy = textToCopy + "\n\n";

    textToCopy = textToCopy + `${styledAssess}: \n`;
    textToCopy =
      textToCopy +
      (note?.assessment && note?.assessment.length > 0
        ? strip(note?.assessment)
        : "");
    textToCopy = textToCopy + "\n\n";

    textToCopy = textToCopy + `${styledPlan}: \n`;
    textToCopy =
      textToCopy +
      (note?.plan && note?.plan.length > 0 ? strip(note?.plan) : "");
    textToCopy = textToCopy + "\n\n";

    textToCopy =
      textToCopy +
      (note?.additionalNotes && note?.additionalNotes.length > 0
        ? `${styledAddNotes}: \n${strip(note?.additionalNotes)}`
        : "");
  }

  const successMessage = `Copied entire note! Now go ahead and paste it where you wish. ${
    note?.hasBeenExported || isForSharedExport
      ? ""
      : "Your note has been marked as exported."
  }`;

  return writeToClipboardWithPimsFormat(
    stripNbsp(textToCopy),
    effectiveFormat,
  )
    .then(() => {
      alert("info", successMessage);
      mixpanel.track("Copied Note", {
        copyType: "full_note",
        pimsExportFormat: effectiveFormat,
      });
    })
    .catch(() => alert("error", "Failed to copy to clipboard."));
}
